import { observer } from "mobx-react-lite";
import { useSingleton } from "../injection";
import { RouteStore } from "./RouteStore";

export const AccessOverlay = observer(() => {
    const routeStore = useSingleton(RouteStore);

    return <>{routeStore.accessOverlay}</>;
});
